import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Floorplan(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M2.111.536c-.87 0-1.575.705-1.575 1.575V17.89a1.575 1.575 0 001.575 1.575H17.89c.87 0 1.575-.705 1.575-1.575v-6.296c0-.87-.705-1.575-1.575-1.575h-7.224V7.31a.575.575 0 00-1.15 0v2.707H7.089a.575.575 0 100 1.15h2.426v.737L7.904 13.53a.575.575 0 10.816.81l1.782-1.796a.574.574 0 00.163-.472v-.903h7.224c.235 0 .425.19.425.425v6.296c0 .235-.19.425-.425.425h-7.282c.038-.135.058-.278.058-.425v-1.917a.575.575 0 00-1.15 0v1.917c0 .234-.19.424-.423.425h-6.98a.425.425 0 01-.425-.425v-6.296c0-.235.19-.425.424-.425H3.37a.575.575 0 100-1.15H2.111c-.147 0-.29.02-.425.058V2.11c0-.235.19-.425.425-.425H9.09c.235 0 .425.19.425.425v1.281L7.904 5.016a.575.575 0 10.816.81l1.643-1.656a.575.575 0 00.3-.468.577.577 0 00.002-.144V2.111c0-.87-.705-1.575-1.575-1.575H2.11z"
  }));
}

export { Floorplan };
//# sourceMappingURL=Floorplan.js.map